/* KPI stat card — a Card with a secondary label, large primary value, and an
   optional trailing delta hint. Used in the Expense > Reports header row. */
import type * as React from 'react';
import { cn } from '../util/cn';
import { Card } from './Card';

export type KpiProps = {
  label: string;
  value: string;
  hint?: string;
  icon?: React.ReactNode;
  className?: string;
};

export function Kpi({ label, value, hint, icon, className }: KpiProps) {
  return (
    <Card className={cn('p-5', className)}>
      <div className="flex items-start justify-between">
        <p className="font-inter text-content-secondary text-sm">{label}</p>
        {icon && (
          <span className="text-content-secondary [&>svg]:size-icon-md">
            {icon}
          </span>
        )}
      </div>
      <p className="mt-2 font-sans font-semibold text-3xl text-content-primary">
        {value}
      </p>
      {hint && (
        <p className="mt-1 font-inter text-content-secondary text-xs">{hint}</p>
      )}
    </Card>
  );
}
